export { default } from './DialogContentText';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/DialogContentText/index.js
// module id = 820
// module chunks = 2